/**
 * Qual dos dois preços de hotel vale para este pet.
 *
 * `withDaycarePlan` nulo significa "a clínica não diferencia": quem não quiser
 * dois preços não precisa preencher nada e todo mundo paga a faixa padrão.
 * Zero, por outro lado, é um preço legítimo — daí a checagem ser por `null`.
 */
export type HotelPriceTier = "with_daycare_plan" | "standard";

export interface HotelPrice {
  tier: HotelPriceTier;
  amount: number | null;
}

export function resolveHotelPrice({
  standard,
  withDaycarePlan,
  hasActiveDaycarePlan,
}: {
  standard: number | null;
  withDaycarePlan: number | null;
  hasActiveDaycarePlan: boolean;
}): HotelPrice {
  if (hasActiveDaycarePlan && withDaycarePlan !== null) {
    return { tier: "with_daycare_plan", amount: withDaycarePlan };
  }
  return { tier: "standard", amount: standard };
}
